<template>
  <div class="Decoration">
    <Back />

    <ProductIntro
      title="Peinture et décoration"
      image="/images/main/decoration.jpg"
      icon1="format-paint"
      text1="Peinture et revêtement mural"
      icon2="shape-rectangle-plus"
      text2="Sol vynil et moquette"
      icon3="palette"
      text3="Pose de parquet"
    />

    <section class="section">
      <div class="container">
        <ProductParagraph
          title="Nous sommes les maîtres de la couleur"
          text="
          Nous vous proposons un large choix de travaux d’intérieurs, peintures, pose de papiers peints, de revêtements muraux décoratifs, de peintures à effets ...
          En manque d’inspiration, aucun problème, nous pouvons vous soumettre un projet de <b>home staging</b> virtuel.
          Nous vous fournirons un photo montage de votre futur réalisation, cela vous permettra de vous projeter dans votre nouvelle intérieure et d’ajuster vos choix de couleurs et matériaux.
          "
          conclusion="Pour un intérieur à votre image !"
        />
        <br />
        <Card
          title="Nous posons vos sols vinyl et moquette"
          text="
          Nous vous aidons à faire votre choix et réalisons un état des lieux de vos besoins.
          Ainsi, nous vous proposerons les matériaux les plus adaptés et vous fournirons
          un échantillon de sol pour que vous puissiez choisir le revêtement qui vous convient.
          "
          conclusion="Un nouveau sol et c’est tout votre décor qui s’offre une nouvelle jeunesse !"
          image="/images/secondary/decoration.jpg"
        />

        <br />
        <br />

        <ProductParagraph
          title="Nous posons vos parquets massifs, stratifiés ou contre-collé"
          text="
          Authentique, intemporel, chaleureux et élégant, le parquet bois demande un savoir-faire
          de pose unique pour vous garantir le plus beau résultat !
          Notre équipe de professionnels saura répondre à toutes vos attentes.
          "
          conclusion="Ambiance intemporelle garantie !"
        />
      </div>
    </section>
  </div>
</template>

<script>
// CSS Extension
import "bulma-pricingtable/dist/css/bulma-pricingtable.min.css";

// Components
import ProductIntro from "../components/ProductIntro";
import ProductParagraph from "../components/ProductParagraph";
import Card from "../components/Card";
import Back from "@/components/Back";

export default {
  name: "Decoration",
  components: {
    ProductIntro,
    ProductParagraph,
    Card,
    Back
  }
};
</script>